export default __webpack_public_path__ + "static/media/beyonce.3b8c1981.gif";